import script from "./user.vue?vue&type=script&lang=ts&setup=true"
export * from "./user.vue?vue&type=script&lang=ts&setup=true"

import "./user.scss?vue&type=style&index=0&id=0c93a43e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c93a43e"]])

export default __exports__